/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalEmrDocument } from './ExternalEmrDocument';
import {
    ExternalEmrDocumentFromJSON,
    ExternalEmrDocumentFromJSONTyped,
    ExternalEmrDocumentToJSON,
    ExternalEmrDocumentToJSONTyped,
} from './ExternalEmrDocument';

/**
 * 
 * @export
 * @interface ExternalEmrDocumentList
 */
export interface ExternalEmrDocumentList {
    /**
     * True while a pull is in flight for this patient. A failed pull stays true until its DLQ message is redriven and succeeds.
     */
    is_pulling: boolean;
    /**
     * When a pull last ran to completion for this re-auth cycle. Null means one has never finished, which is what distinguishes a cycle nobody has collected for from one Net Health returned nothing for.
     */
    documents_pulled_at?: string | null;
    /**
     * Start of the KeyDate window this cycle's documents were asked for, YYYY-MM-DD and inclusive. The list is filtered by it.
     */
    key_date_start?: string | null;
    /**
     * End of the KeyDate window, YYYY-MM-DD and inclusive.
     */
    key_date_end?: string | null;
    /**
     * 
     */
    documents: Array<ExternalEmrDocument>;
}

/**
 * Check if a given object implements the ExternalEmrDocumentList interface.
 */
export function instanceOfExternalEmrDocumentList(value: object): value is ExternalEmrDocumentList {
    if (!('is_pulling' in value) || value['is_pulling'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function ExternalEmrDocumentListFromJSON(json: any): ExternalEmrDocumentList {
    return ExternalEmrDocumentListFromJSONTyped(json, false);
}

export function ExternalEmrDocumentListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEmrDocumentList {
    if (json == null) {
        return json;
    }
    return {
        
        'is_pulling': json['is_pulling'],
        'documents_pulled_at': json['documents_pulled_at'] === undefined ? undefined : json['documents_pulled_at'] === null ? null : json['documents_pulled_at'],
        'key_date_start': json['key_date_start'] === undefined ? undefined : json['key_date_start'] === null ? null : json['key_date_start'],
        'key_date_end': json['key_date_end'] === undefined ? undefined : json['key_date_end'] === null ? null : json['key_date_end'],
        'documents': ((json['documents'] as Array<any>).map(ExternalEmrDocumentFromJSON)),
    };
}

export function ExternalEmrDocumentListToJSON(json: any): ExternalEmrDocumentList {
    return ExternalEmrDocumentListToJSONTyped(json, false);
}

export function ExternalEmrDocumentListToJSONTyped(value?: ExternalEmrDocumentList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_pulling': value['is_pulling'],
        'documents_pulled_at': value['documents_pulled_at'],
        'key_date_start': value['key_date_start'],
        'key_date_end': value['key_date_end'],
        'documents': ((value['documents'] as Array<any>).map(ExternalEmrDocumentToJSON)),
    };
}

